export const platformName = "PHOTO WALL BY VISRA";
export const logoUrl = "/branding/photo-wall-by-visra.png";

export function Brand() {
  return (
    <div className="brand brand-logo">
      <img src={logoUrl} alt={platformName} width="1659" height="948" />
      <span className="brand-caption">
        PHOTO WALL <strong>BY VISRA</strong>
      </span>
    </div>
  );
}
